(() => {
  const dialog = document.querySelector('#bh-wishlist');
  if (!dialog) return;
  const status = dialog.querySelector('[data-bh-wishlist-status]');
  const container = dialog.querySelector('[data-bh-wishlist-items]');
  let csrf;
  let busy = false;
  let opener;
  let savedVariants = new Set();
  let initialLoad = Promise.resolve();
  const selection = new Set();
  let renderedItems = [];
  const labels = { off: '未訂閱通知', waiting: '已訂閱一次補貨通知', sending: '通知處理中', sent: '已寄送本次通知', unknown: '寄送結果待核對', failed: '通知未能寄送，請聯絡客服' };

  function message(text) { status.textContent = text; }
  function selectedVariant(add) {
    const card = add.closest('.collection-product-card');
    return card
      ? (card.querySelector('.variant-selector')?.value || add.dataset.variantId)
      : document.querySelector('#product-form [name="id"]')?.value;
  }
  function syncStars() {
    document.querySelectorAll('[data-bh-wishlist-add]').forEach(element => {
      const saved = savedVariants.has(String(selectedVariant(element)));
      element.setAttribute('aria-pressed', String(saved));
      element.setAttribute('aria-label', saved ? '已加入 Wishlist，開啟收藏' : '將所選款式加入 Wishlist');
    });
  }
  function requireMember() {
    if (dialog.dataset.member === 'true') return true;
    message('請先登入會員，收藏才會保存在你的帳戶。');
    container.replaceChildren();
    const login = document.createElement('a');
    login.href = dialog.dataset.login;
    login.textContent = '登入會員';
    login.className = 'bh-wishlist-primary';
    container.append(login);
    return false;
  }
  async function request(body) {
    const response = await fetch(dialog.dataset.endpoint, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      signal: AbortSignal.timeout(20000),
      headers: body ? { 'Content-Type': 'application/json', 'X-Beehive-CSRF': csrf } : {},
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    let result;
    try { result = await response.json(); } catch { throw new Error('Wishlist 回應異常，請稍後再試。'); }
    if (!response.ok) throw new Error(result.error || 'Wishlist 暫時無法使用。');
    if (result.csrf) csrf = result.csrf;
    savedVariants = new Set(result.items.map(item => String(item.variantId)));
    dialog.querySelector('[data-bh-wishlist-count]').textContent = `${result.items.length} / 100`;
    syncStars();
    return result;
  }
  function render(items) {
    renderedItems = items;
    container.replaceChildren();
    dialog.querySelector('[data-bh-wishlist-count]').textContent = `${items.length} / 100`;
    const currentIds = new Set(items.map(item => item.variantId));
    for (const id of selection) if (!currentIds.has(id)) selection.delete(id);
    if (!items.length) {
      const empty = document.createElement('p');
      empty.className = 'bh-wishlist-empty';
      empty.textContent = '未有收藏商品。點選商品右上角的星號，將喜歡的款式收藏在這裡。';
      container.append(empty);
      return;
    }
    const controls = document.createElement('div');
    controls.className = 'bh-wishlist-selection';
    const selectLabel = document.createElement('label');
    const selectAll = document.createElement('input');
    selectAll.type = 'checkbox';
    selectAll.setAttribute('aria-label', '全選收藏');
    const selectedCount = document.createElement('span');
    selectLabel.append(selectAll, document.createTextNode(' 全選'));
    controls.append(selectLabel, selectedCount);
    container.append(controls);
    const list = document.createElement('div');
    list.setAttribute('role', 'list');
    const checkboxes = [];
    for (const item of items) {
      const row = document.createElement('article');
      row.className = 'bh-wishlist-item';
      row.setAttribute('role', 'listitem');
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.checked = selection.has(item.variantId);
      checkbox.setAttribute('aria-label', `選擇 ${item.title}${item.variantTitle === 'Default Title' ? '' : ` / ${item.variantTitle}`}`);
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) selection.add(item.variantId);
        else selection.delete(item.variantId);
        updateSelection();
      });
      checkboxes.push({ checkbox, id: item.variantId });
      const link = document.createElement('a');
      const url = new URL(item.url);
      if (url.origin !== 'https://beehivetcg.com') throw new Error('商品連結無效。');
      link.href = url.href;
      link.className = 'bh-wishlist-item-title';
      link.textContent = item.title;
      const thumbnail = document.createElement('a');
      thumbnail.href = url.href;
      thumbnail.className = 'bh-wishlist-thumbnail';
      thumbnail.setAttribute('aria-label', item.title);
      if (item.image) {
        const source = new URL(item.image.url);
        if (source.protocol !== 'https:' || source.hostname !== 'cdn.shopify.com') throw new Error('商品圖片連結無效。');
        source.searchParams.set('width', '144');
        const image = document.createElement('img');
        image.src = source.href;
        image.alt = item.image.altText || item.title;
        image.loading = 'lazy';
        image.width = 64;
        image.height = 72;
        thumbnail.append(image);
      } else {
        thumbnail.textContent = '暫無圖片';
      }
      const details = document.createElement('div');
      details.className = 'bh-wishlist-details';
      details.append(link);
      if (item.variantTitle && item.variantTitle !== 'Default Title') {
        const variant = document.createElement('p');
        variant.className = 'bh-wishlist-variant';
        variant.textContent = item.variantTitle;
        details.append(variant);
      }
      const price = document.createElement('p');
      price.className = 'bh-wishlist-price';
      price.textContent = item.price && typeof item.price.amount === 'string' &&
        /^\d+(\.\d+)?$/.test(item.price.amount) && Number.isFinite(Number(item.price.amount)) &&
        /^[A-Z]{3}$/.test(item.price.currencyCode)
        ? new Intl.NumberFormat('zh-HK', { style: 'currency', currency: item.price.currencyCode, currencyDisplay: 'code' }).format(Number(item.price.amount))
        : '價錢暫未能提供';
      const state = document.createElement('p');
      state.className = 'bh-wishlist-state';
      state.dataset.state = item.notificationStatus;
      state.textContent = labels[item.notificationStatus] || '通知狀態待確認';
      details.append(price, state);
      row.append(checkbox, thumbnail, details);
      list.append(row);
    }
    container.append(list);
    const actions = document.createElement('div');
    actions.className = 'bh-wishlist-bulk';
    const consentLabel = document.createElement('label');
    consentLabel.className = 'bh-wishlist-consent';
    const consent = document.createElement('input');
    consent.type = 'checkbox';
    consentLabel.append(consent, document.createTextNode(' 同意所選售罄款式補貨時寄一次電郵通知'));
    const bulk = action => {
      if (action === 'subscribe' && !consent.checked) { message('請先勾選補貨電郵通知。'); return; }
      return mutate({ action, variantIds: [...selection], ...(action === 'subscribe' ? { consent: true } : {}) });
    };
    const subscribe = button('訂閱補貨通知', () => bulk('subscribe'));
    subscribe.className = 'bh-wishlist-primary';
    const cancel = button('取消訂閱', () => bulk('cancel'));
    const remove = button('移除收藏', () => bulk('remove'));
    remove.className = 'bh-wishlist-remove';
    const buttons = document.createElement('div');
    buttons.className = 'bh-wishlist-bulk-buttons';
    buttons.append(subscribe, cancel, remove);
    actions.append(consentLabel, buttons);
    container.append(actions);
    function updateSelection() {
      const chosen = items.filter(item => selection.has(item.variantId));
      selectedCount.textContent = `已選 ${chosen.length} 項`;
      selectAll.checked = chosen.length === items.length;
      selectAll.indeterminate = chosen.length > 0 && chosen.length < items.length;
      subscribe.disabled = busy || !chosen.some(item => item.soldOut && ['off', 'sent'].includes(item.notificationStatus));
      cancel.disabled = busy || !chosen.some(item => ['waiting', 'sending'].includes(item.notificationStatus));
      remove.disabled = busy || !chosen.length;
    }
    selectAll.addEventListener('change', () => {
      checkboxes.forEach(({ checkbox, id }) => {
        checkbox.checked = selectAll.checked;
        if (selectAll.checked) selection.add(id);
        else selection.delete(id);
      });
      updateSelection();
    });
    updateSelection();
  }
  function button(text, action) {
    const element = document.createElement('button');
    element.type = 'button';
    element.textContent = text;
    element.addEventListener('click', action);
    return element;
  }
  async function mutate(body) {
    if (busy) return;
    busy = true;
    container.querySelectorAll('button, input').forEach(element => { element.disabled = true; });
    let result;
    try {
      await initialLoad;
      if (!csrf) await request();
      result = await request(body);
      const reasons = { missing: '已不在收藏', alreadySubscribed: '已訂閱', requiresReview: '處理中／待核對', notSoldOut: '非可訂閱售罄款式', notSubscribed: '未有待寄通知' };
      message(result.batch
        ? `已處理 ${result.batch.processed} 項；跳過 ${result.batch.selected - result.batch.processed} 項。${Object.entries(result.batch.skipped).map(([reason, count]) => `${reasons[reason] || reason}：${count}`).join('；')}`
        : 'Wishlist 已更新。');
    } catch (error) { message(error.message); }
    finally {
      busy = false;
      container.querySelectorAll('button, input').forEach(element => { element.disabled = false; });
      render(result ? result.items : renderedItems);
    }
  }
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-bh-wishlist-open]');
    const add = event.target.closest('[data-bh-wishlist-add]');
    if (!open && !add) return;
    event.preventDefault();
    if (!dialog.open) {
      opener = open || add;
      dialog.showModal();
      document.documentElement.classList.add('bh-wishlist-is-open');
      document.querySelectorAll('[data-bh-wishlist-open]').forEach(element => element.setAttribute('aria-expanded', 'true'));
    }
    if (!requireMember()) return;
    if (busy) return;
    message('載入中…');
    if (add) {
      const variantId = selectedVariant(add);
      if (!variantId) { message('請先選擇款式。'); return; }
      if (savedVariants.has(String(variantId))) {
        try { render((await request()).items); message(''); }
        catch (error) { message(error.message); }
        return;
      }
      await mutate({ action: 'add', variantId });
    } else {
      try { await initialLoad; render((await request()).items); message(''); }
      catch (error) { message(error.message); }
    }
  });
  dialog.querySelector('[data-bh-wishlist-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    dialog.close();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('bh-wishlist-is-open');
    document.querySelectorAll('[data-bh-wishlist-open]').forEach(element => element.setAttribute('aria-expanded', 'false'));
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  document.addEventListener('change', syncStars);
  const products = document.querySelector('.collection-product-wrapper');
  if (products) new MutationObserver(syncStars).observe(products, { childList: true, subtree: true });
  syncStars();
  if (dialog.dataset.member === 'true') {
    initialLoad = request().catch(error => message(error.message));
  }
})();
